import { enqueueLog } from './log-batcher.js';
import { log as bufferLog } from '../diagnostic/log-buffer.js';
import { captureError } from '../sentry.js';

/**
 * Global JS hata yakalama — window.error + unhandledrejection.
 * Hatalar log-batcher kuyruğuna + diagnostic log-buffer'a + Sentry'ye yazılır.
 *
 * Memory: decision_pwa_resilience.md §12
 */
export function installErrorHandlers(): void {
    window.addEventListener('error', (e: ErrorEvent) => {
        const message = e.message || 'bilinmeyen hata';
        const context: Record<string, unknown> = {
            type: 'window.error',
            filename: e.filename,
            lineno: e.lineno,
            colno: e.colno,
        };
        if (e.error?.stack) {
            context.stack = String(e.error.stack).slice(0, 4000);
        }
        enqueueLog({ ts: Date.now(), level: 'error', message, context });
        bufferLog('error', message);
        captureError(e.error ?? message, context);
    });

    window.addEventListener('unhandledrejection', (e: PromiseRejectionEvent) => {
        const reason = e.reason;
        const message = reason instanceof Error ? reason.message : String(reason);
        const context: Record<string, unknown> = { type: 'unhandledrejection' };
        if (reason instanceof Error && reason.stack) {
            context.stack = reason.stack.slice(0, 4000);
        }
        enqueueLog({ ts: Date.now(), level: 'error', message, context });
        bufferLog('error', message);
        captureError(reason, context);
    });

    window.addEventListener('online', () => bufferLog('info', 'network online'));
    window.addEventListener('offline', () => bufferLog('warn', 'network offline'));

    console.info('[telemetry] error handler kuruldu');
}
